import type { Environment } from '@change-corgi/config/environments';

import { recaptchaInvisibleKey, recaptchaKey } from './data';

export function getRecaptchaKey(env: Environment, mode: 'visible' | 'invisible' = 'visible'): string {
	// eslint-disable-next-line security/detect-object-injection
	return mode === 'visible' ? recaptchaKey[env] : recaptchaInvisibleKey[env];
}
